var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5C19.6406 0.5 21 1.85938 21 3.5V18.5C21 20.1875 19.6406 21.5 18 21.5H3C1.3125 21.5 0 20.1875 0 18.5V3.5C0 1.85938 1.3125 0.5 3 0.5H18ZM15.2344 5.5625C14.5312 4.85938 13.3125 4.85938 12.6094 5.5625L11.5781 6.59375L14.9062 9.92188L15.9375 8.89062C16.6406 8.14062 16.6406 6.96875 15.9375 6.26562L15.2344 5.5625ZM5.20312 13.25L4.5 16.0625C4.45312 16.3438 4.5 16.625 4.6875 16.8125C4.875 17 5.15625 17.0469 5.39062 17L8.25 16.2969C8.48438 16.2031 8.71875 16.0625 8.90625 15.875L13.875 10.9531L10.5469 7.625L5.57812 12.5469C5.39062 12.7812 5.25 13.0156 5.20312 13.25Z",
    fill: "#F67924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d34c1f258de742a2b9740631292f7855.svg";
export { ForwardRef as ReactComponent };